import { DOMService } from "../Common/DOMService";

const ValidationFocusDirective = function ($timeout, DOM: DOMService) {
    function expandParentCollapsible(element) {
        var collapsible = element.closest(".collapsible-body");

        if (collapsible.length == 0) return false;

        var header = collapsible.prev(".collapsible-header");

        if (header.length == 0) return false;

        var isClicked = expandParentCollapsible(header.parent());

        if (!header.hasClass("active")) {
            DOM.click(header);
            return true;
        }

        return isClicked;
    }

    return {
        restrict: 'A',
        link: function (scope, elm, attrs, ctrl) {
            elm.on("submit", function () {
                $timeout(function () {
                    function scroll() {
                        DOM.scrollIntoView(scrollTarget);
                    }

                    function scrollAndFocus() {
                        if (!errorElement.hasClass("select-dropdown")) {
                            DOM.focus(errorElement);
                            $timeout(scroll, 200);
                        } else {
                            scroll();
                        }
                    }

                    var errorElement = elm.find(".invalid:first");

                    if (errorElement.length > 0) {
                        var needsdelay = expandParentCollapsible(errorElement);

                        var inputRow = errorElement.closest(".input-field, .col, .collection-item, li")
                            .find("label");

                        var scrollTarget = inputRow.length > 0
                            ? inputRow[0]
                            : errorElement[0];

                        if (needsdelay) {
                            $timeout(scrollAndFocus, 200);
                        } else {
                            scrollAndFocus();
                        }
                    }
                });
            });
        }
    }
};

ValidationFocusDirective.$inject = ["$timeout", "DOM"];

export { ValidationFocusDirective };